var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { normalize } from 'polished';
import { createGlobalStyle } from 'styled-components';
import renderFont from '../renderFont';
export var generateFontDefinitions = function (fontDefinitions) {
    return fontDefinitions &&
        fontDefinitions
            .map(function (definition) {
            return (definition === null || definition === void 0 ? void 0 : definition.fontFamily) &&
                "@font-face {\n    font-family: '" + definition.fontFamily + "';\n    " + definition.options + "\n  }";
        })
            .join('\n');
};
/**
 * Component conaining global styles
 */
export var GlobalStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  ", "\n \n  *,\n  *:before,\n  *:after {\n    outline: 0;\n    box-sizing: border-box;\n  }\n\n  html {\n    font-size: ", ";\n  }\n\n  html body {\n    margin: 0;\n    color: ", ";\n    line-height: 1.5;\n    background-color: ", ";\n    ", "\n  }\n  \n  a {\n    background: transparent;\n    \n    &:link,\n    &:visited,\n    &:hover,\n    &:active {\n      outline: 0;\n      color: inherit;\n    }\n  }\n"], ["\n  ", "\n\n  ", "\n \n  *,\n  *:before,\n  *:after {\n    outline: 0;\n    box-sizing: border-box;\n  }\n\n  html {\n    font-size: ", ";\n  }\n\n  html body {\n    margin: 0;\n    color: ", ";\n    line-height: 1.5;\n    background-color: ", ";\n    ", "\n  }\n  \n  a {\n    background: transparent;\n    \n    &:link,\n    &:visited,\n    &:hover,\n    &:active {\n      outline: 0;\n      color: inherit;\n    }\n  }\n"])), normalize(), function (_a) {
    var theme = _a.theme;
    return generateFontDefinitions(theme.global.fontDefinitions);
}, function (_a) {
    var theme = _a.theme;
    return theme.global.baseFontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.base.color.text;
}, function (_a) {
    var theme = _a.theme;
    return theme.base.color.normal;
}, function (_a) {
    var theme = _a.theme;
    return renderFont('base', 'normal', theme);
});
export default GlobalStyle;
var templateObject_1;
//# sourceMappingURL=index.js.map